module.exports = __webpack_public_path__ + "static/media/skill7_pos_en.7f00490b.txt";